import {Injectable} from '@angular/core';
import {Http, RequestOptions, URLSearchParams, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {SettingsProvider} from './settings';
import {ConstantProvider} from "./constants";

@Injectable()
export class AuthenticationProvider {
    url: string;
    public authenticated: boolean = false;
    public token: string = '';
    public user: any = {id: 0, nome: '', cpf: '', grupo: 0};
    public session: any = {};

    constructor(public http: Http, public settings: SettingsProvider, public constants: ConstantProvider) {
        this.url = this.constants.API_URL;
    }

    authenticate(usuario) {
        var creds = "username=" + usuario.name + "&password=" + usuario.password;
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return new Promise((resolve, reject) => {
            this
                .http
                .post(this.url + "/login.php", creds, {headers: headers})
                .subscribe((data:any) => {
                    let resp:any = JSON.parse(data['_body']);
                    if(!resp.success) {
                        resolve(resp);
                    } else{
                        this.session = resp;
                        this.authenticated = true;
                        this.token = this.session.access_token;
                        this.storeUserCredentials(this.session);
                        resolve(this.session)
                    }
                }, (err) => {
                    reject(err.json())
                });
        });
    }

    post(endpoint: string, body: any) {
        return new Promise((resolve, reject) => {
            return this.http.post(this.url + '/' + endpoint, body)
                .subscribe(res => {
                        resolve(res.json())
                    },
                    (error: any) => {
                        reject(error)
                    });
        });

    }

    obter(endpoint: string, endcom?: string, ignoreCache?: boolean, params?: any, options?: RequestOptions) {
        return new Promise((resolve, reject) => {
            if (!endcom) {
                endcom = '';
            }
            this.settings
                .loadCachedData(endpoint)
                .then(res => {
                    if (res != undefined) {
                        resolve(res)
                    }
                    else {
                        this.settings.loadSetting('session')
                            .then(res => {
                                if (!options) {
                                    options = new RequestOptions();
                                }

                                options.headers = new Headers();
                                options.headers.append('Authorization', 'Bearer ' + this.token);

                                // Support easy query params for GET requests
                                if (params) {
                                    let p = new URLSearchParams();
                                    for (let k in params) {
                                        p.set(k, params[k]);
                                    }
                                    // Set the search field if we have params and don't already have
                                    // a search field set in options.
                                    options.search = !options.search && p || options.search;
                                }
                                this.http
                                    .get(this.url + '/' + endpoint + endcom, options)
                                    .subscribe((res) => {
                                        this.settings.saveCachedData(endpoint, res.json());
                                        resolve(res.json());
                                    }, (err) => {
                                        reject(err)
                                    });
                            });

                    }
                });
        });
    }

    storeUserCredentials(ssn) {
        return new Promise(resolve => {
            this.authenticated = true;
            ssn.authenticated = true;
            ssn.dtultlogin = new Date();
            ssn.dtexpires = ssn.dtultlogin;
            ssn.dtexpires = new Date(ssn.dtexpires.getTime() + (eval(ssn.expires_in) * 1000));

            this.settings.saveSetting('session', ssn);
        });
    }

    loadUserCredentials() {
        return new Promise(resolve => {
            this.settings
                .loadSetting("session")
                .then(ssn => {
                    this.session = ssn;
                    if (this.session != undefined) {
                        this.authenticated = this.session.authenticated;
                    }
                    resolve(ssn);
                });
        });
    }

    destroyUserCredentials() {
        this.authenticated = false;
        return new Promise(resolve => {
            this.settings.eraseData();
            resolve(true);
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/authentication.ts